/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type CategoryType = 'DISEASES' | 'SPECIALTIES' | 'CHARITY_FOCUSES';

export const CategoryType = {
    DISEASES: 'DISEASES' as CategoryType,
    SPECIALTIES: 'SPECIALTIES' as CategoryType,
    CHARITYFOCUSES: 'CHARITY_FOCUSES' as CategoryType
};